export type UserStatus = 'ACTIVE' | 'INACTIVE' | 'LOCKED' | 'PENDING_VERIFICATION';

export const UserStatusEnum = {
    Active: 'ACTIVE' as UserStatus,
    Inactive: 'INACTIVE' as UserStatus,
    Locked: 'LOCKED' as UserStatus,
    PendingVerification: 'PENDING_VERIFICATION' as UserStatus,
};
